import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "subpage-header__logo" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "./" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/public/home_page/img/logo.png",
      alt: "ロゴ"
    })
  ])
], -1)
const _hoisted_2 = { class: "page-login" }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "login-title" }, "新規登録", -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p class=\"description\"> ボタンをクリックすると、 <a href=\"/public/kiyaku.html\">利用規約</a>と <a href=\"/public/pp.html\">プライバシーポリシー</a>が適用されます。 </p><div class=\"link-container\"><a href=\"./login\" class=\"create-account\"><span>ログインはこちら</span></a></div>", 2)

import OAuthLoginSection from './section/OAuthLoginSection.vue';
import RegisterForm from './section/RegisterForm.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRegister',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-var-requires */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _hoisted_1,
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(OAuthLoginSection),
        _createVNode(RegisterForm),
        _hoisted_5
      ])
    ])
  ]))
}
}

})